export const buttons = [
  {
    id: 1,
    title: 'Янги',
    value: true,
  },
  {
    id: 2,
    title: 'Архив',
    value: false,
  },
];